import { registryAPI } from '@/providers/apis/registry/registry';
import { sortByProperty } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'registry',
})


export default class Registry extends Vue {


    // -----------------------------------------------------------
    // Properties

    private tableFields: any = [
        {
            label: 'Tool Provider',
            key: 'providerName',
        },
        {
            label: 'Tool',
            key: 'tool',
        },
        {
            label: 'Grade levels',
            key: 'gradeLevels',
        },
        {
            label: 'Subject',
            key: 'subject',
        },
        {
            label: 'Last upload Date',
            key: 'lastUpdate',
        },
        {
            label: 'Data Volume',
            key: 'dataVol',
        },
    ];


    private providerList: any = [];

    private filterList: any = [];

    private searchTerms: string = '';



    // ---------------------------------------------------------
    // Hooks

    private created() {
        this.fetchProvidersList();
    }

    private onSearchItems() {
        const value = this.searchTerms;
        this.filterList = [...this.providerList].filter(
            (item: any) => item.providerName.toLowerCase().startsWith(value.toLowerCase())
                || item.tool.toLowerCase().startsWith(value.toLowerCase()));
    }


    // ------------------------------------------------------------------------
    // Methods

    private fetchProvidersList() {
        registryAPI.fetchRegistryList().then((registry) => {
            sortByProperty(registry, 'providerName', 'ASC');
            this.providerList = registry;
            this.filterList = registry;
        });
    }

}
